<template>
  <form
    v-if="!loading && customField"
    @submit.prevent.stop=""
    key="needkey">
    <div
      class="is-padding-large has-background-white--darken1">
      <div class="columns is-multiline">
        <div
          class="column is-4">
          <div class="field">
            <v-input
              id="customField-title"
              name="customField-title"
              @input="customField.title = $event"
              :model="customField.title"
              v-validate="'min:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Titre du champ">
              <r-label
                slot="label"
                :label="'Titre du champ'"
                :value="customField.title"></r-label>
            </v-input>
          </div>
        </div>
        <div
          class="column is-4">
          <r-label
            :is-required="true"
            label="Type du champ"
            :value="customField.input_type"></r-label>
          <div class="select is-fullwidth">
            <select v-model="customField.input_type">
              <option :value="null">
                Selectionnez le type du champ
              </option>
              <option
                v-for="type in inputTypes"
                :value="type.value"
                :key="type.value">
                {{ type.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="column is-1"></div>
        <!-- <div
          v-if="customField.input_type !== 'checkbox'"
          class="column columns is-column is-gapless is-space-between is-marginless is-3 is-padding-top">
          <r-label
            label="Donnée obligatoire"
            :value="customField.input_config.mandatory"
            for-id="mandatory"
            :is-required="false"></r-label>
          <div class="">
            <input
              id="mandatory"
              type="checkbox"
              :name="`mandatory`"
              class="switch is-success is-rounded is-medium"
              v-model="customField.input_config.mandatory">
            <label for="mandatory">
              <span>{{ customField.input_config.mandatory ? 'Oui' : 'Non' }}</span>
            </label>
          </div>
        </div> -->
      </div>
    </div>
    <div
      class="is-flex is-3 is-padding-left-small is-padding-right-small border-design is-padding-top-xsmall is-padding-bottom-xsmall"
      :class="!customField.input_config.filterable ? 'is-border-top has-background-light is-border-left is-border-right ' : 'has-background-dark'">
      <div
        class="">
        <input
          id="filterable"
          type="checkbox"
          :name="`filterable`"
          :disabled="false"
          class="switch is-success is-rounded is-light"
          v-model="customField.input_config.filterable">
        <label for="filterable">
        </label>
      </div>
      <r-label
        class="is-self-centered has-text-weight-light is-padding-left-xxsmall"
        :class="!customField.input_config.filterable ? '' : 'has-text-white'"
        style="font-size: 13px !important; color: #24323b"
        label="APPLIQUER LE FILTRAGE SUR CETTE DONNÉE"
        :value="customField.input_config.filterable"
        for-id="filterable"
        :is-required="false"></r-label>
    </div>
    <div
      class="is-padding-large has-background-white-bis">
      <div class="columns is-multiline">
        <div
          v-if="customField.input_type && ['number'].includes(customField.input_type)"
          class="column is-4">
          <div class="field">
            <v-input
              id="customField-default"
              name="customField-default"
              @input="customField.input_config.default = $event"
              :model="customField.input_config.default"
              :errors-bag="errors"
              :number="true"
              input-type="number"
              data-vv-value-path="val"
              data-vv-as="Valeur par défaut">
              <r-label
                slot="label"
                :is-required="false"
                :label="'Valeur par défaut'"></r-label>
            </v-input>
          </div>
        </div>
        <div
          v-else-if="customField.input_type && !['date', 'checkbox'].includes(customField.input_type)"
          class="column is-4">
          <div class="field">
            <v-input
              id="customField-default"
              name="customField-default"
              @input="customField.input_config.default = $event"
              :model="customField.input_config.default"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Valeur par défaut">
              <r-label
                slot="label"
                :is-required="false"
                :label="'Valeur par défaut'"></r-label>
            </v-input>
          </div>
        </div>
        <div
          v-if="customField.input_type"
          class="column is-4">
          <r-label
            :is-required="false"
            label="Taille du champ"
            :value="customField.input_config.size"></r-label>
          <div class="select is-fullwidth">
            <select v-model="customField.input_config.size">
              <option :value="{ label: 'Selectionnez la taille du champ', value: null }">
                Selectionnez la taille du champ
              </option>
              <option
                v-for="size in inputSizes"
                :value="size"
                :key="size.value">
                {{ size.label }}
              </option>
            </select>
          </div>
        </div>
        <div
          v-if="customField.input_type === 'number'"
          class="column columns is-column is-gapless is-space-between is-marginless is-6 is-padding-top">
          <r-label
            label="Afficher la devise (€)"
            :value="customField.input_config.devise"
            for-id="devise"
            :is-required="false"></r-label>
          <div class="">
            <input
              id="devise"
              type="checkbox"
              :name="`devise`"
              class="switch is-success is-rounded is-medium"
              v-model="customField.input_config.devise">
            <label for="devise">
              <span>{{ customField.input_config.devise ? 'Oui' : 'Non' }}</span>
            </label>
          </div>
        </div>
        <div
          class="column is-12 columns is-multiline"
          v-if="['multiselect', 'select'].includes(customField.input_type)">
          <div
            v-for="(choice, i) in customField.input_config.available_values"
            :key="i">
            <div
              v-if="customField.input_type"
              class="column is-8">
              <div class="field is-flex">
                <v-input
                  :id="'customField-choice' + i"
                  :name="'customField-choice' + i"
                  @input="setAvailableValues($event, i)"
                  :model="customField.input_config.available_values[i].label"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  :data-vv-as="`Choix ${i + 1}`">
                  <r-label
                    slot="label"
                    :label="`Choix ${i + 1}`"
                    :value="customField.input_config.available_values[i].value"></r-label>
                </v-input>
                <div
                  @click="customField.input_config.available_values.splice(i, 1)"
                  class="is-flex-center has-cursor-pointer">
                  <span class="icon is-small is-size-3 is-margin-top is-margin-left-large"><i class="fas fa-trash-alt"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div
            @click="customField.input_config.available_values.push({label: '', value: ''})"
            class="column is-12 has-cursor-pointer columns is-margin-top-small is-marginless">
            <span class="column is-12 has-background-primary has-text-centered has-text-white is-padding-top is-padding-bottom is-uppercase">Ajouter un choix</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="customField.title && customField.input_type"
      class="is-padding-large has-background-white">
      <span class="has-text-weight-semibold is-size-4">Prévisualisation du champ</span>
      <CustomFieldInput
        class="is-margin-top"
        :custom-field="customField"
        :class="`column ${customField.input_config.size.value || 'is-3'}`"
        :value="value"
        @change="value = $event" />
    </div>
    <submit-sticky-buttons
      @submit="submit"
      :loading="loading"
      button-id="customFieldForm"></submit-sticky-buttons>
  </form>
</template>

<script>
import { CustomFields } from '@/mixins'
import { CUSTOM_FIELDS } from '@/mixins/DefaultValues'
import DefaultValues from '../../mixins/DefaultValues'
import { cloneDeep } from 'lodash'
// import CustomFieldInput from '@/components/utils/form/CustomFieldInput'

const emptyCustomField = {
  title: null,
  model_type: 'contact',
  input_type: null,
  input_config: {
    default: null,
    available_values: [],
    mandatory: false,
    size: { label: '1/4', value: 'is-3' },
    filterable: false
  }
}

export default {
  name: 'CustomFieldForm',
  components: {
    CustomFieldInput: () => import('@/components/utils/form/CustomFieldInput')
  },
  mixins: [DefaultValues, CustomFields],
  data () {
    return {
      openedModal: '',
      value: null,
      customField: null,
      loading: false,
      inputSizes: [
        { label: '1/4', value: 'is-3' },
        { label: '1/3', value: 'is-4' },
        { label: '1/2', value: 'is-6' },
        { label: '1', value: 'is-12' }
      ],
      selectChoices: []
    }
  },
  computed: {
    inputTypes () {
      return Object.keys(CUSTOM_FIELDS).map(key => {
        return {
          label: CUSTOM_FIELDS[key],
          value: key
        }
      })
    }
  },
  watch: {
    selectChoices: {
      handler (val) {
        this.customField.input_config.available_values = val
      },
      deep: true
    }
  },
  async created () {
    this.init()
  },
  methods: {
    async init () {
      this.loading = true
      if (this.$route.params.customFieldPk) {
        this.customField = await this.getCustomField(this.$route.params.customFieldPk)
      } else {
        const allCustomFields = await this.getCustomFields()
        this.customField = cloneDeep(emptyCustomField)
        this.customField.input_config.display_order = allCustomFields.length
      }
      this.loading = false
    },
    removeAccents (s) {
      let r = s.toLowerCase()
      r = r.replace(new RegExp(/\s/g), '')
      r = r.replace(new RegExp(/[àáâãäå]/g), 'a')
      r = r.replace(new RegExp(/æ/g), 'ae')
      r = r.replace(new RegExp(/ç/g), 'c')
      r = r.replace(new RegExp(/[èéêë]/g), 'e')
      r = r.replace(new RegExp(/[ìíîï]/g), 'i')
      r = r.replace(new RegExp(/ñ/g), 'n')
      r = r.replace(new RegExp(/[òóôõö]/g), 'o')
      r = r.replace(new RegExp(/œ/g), 'oe')
      r = r.replace(new RegExp(/[ùúûü]/g), 'u')
      r = r.replace(new RegExp(/[ýÿ]/g), 'y')
      r = r.replace(new RegExp(/\W/g), '')
      return r
    },
    setAvailableValues (val, i) {
      this.customField.input_config.available_values[i].label = val
      this.customField.input_config.available_values[i].value = this.removeAccents(val.trim())
    },
    async submit () {
      this.loading = true
      if (this.$route.params.customFieldPk) {
        await this.putCustomField(this.$route.params.customFieldPk, this.customField)
      } else await this.postCustomField(this.customField)
      this.customField = cloneDeep(emptyCustomField)
      this.loading = false
      this.$router.goBack()
    }
  }
}
</script>

<style scoped>
.border-design {
  background-color: #F5F8FA;
  border-width: 1px;
  border-color: #ebebeb;
  border-style: solid;
}
</style>
